<template>
  <div class="animated fadeIn" v-if="$store.getters['auth/isAdmin']">
    <b-row>
  <!-- Financeiro -->
  <b-col md="6">
    <h1 style="margin-top: 2rem; margin-bottom: .5rem;">Financeiro</h1>
    <div style="width: 100%; height: 1px; background-color: #ccc; margin-bottom: 2rem"></div>

    <!-- Recebíveis -->
    <a href="/financials/financials" class="link"><h3>Recebíveis <i class="fa fa-external-link"></i></h3></a>
    <b-row>
      <b-col sm="6" md="6">
        <b-card class="card-accent-primary card-style" header="A Receber">
          <b-card-body class="card-body-style">
            <div v-if="totalToReceive !== null && totalToReceive !== undefined" class="card-body-content">
              <i class="fa fa-money my-success"></i>
              <p>R$ {{ totalToReceive | formatPrice }}</p>
            </div>
            <b-spinner v-else variant="primary" size="lg"></b-spinner>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" md="6">
        <b-card class="card-accent-primary card-style" header="Recebido">
          <b-card-body class="card-body-style">
            <div v-if="totalReceived !== null & totalReceived !== undefined" class="card-body-content">
              <i class="fa fa-credit-card my-success"></i>
              <p>R$ {{ totalReceived | formatPrice }}</p>
            </div>
            <b-spinner v-else variant="primary" size="lg"></b-spinner>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <div class="divider"></div>

    <!-- Reembolsos -->
    <a href="/financials/financials"><h3>Reembolsos <i class="fa fa-external-link"></i></h3></a>
    <b-row>
      <b-col sm="6" md="6">
        <b-card class="card-accent-primary card-style" header="A Pagar - Funcionários">
          <b-card-body class="card-body-style">
            <div v-if="totalToPayEmployees !== null && totalToPayEmployees !== undefined" class="card-body-content">
              <i class="fa fa-money text-danger"></i>
              <p>R$ {{ totalToPayEmployees | formatPrice }}</p>
            </div>
            <b-spinner v-else variant="primary" size="lg"></b-spinner>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" md="6">
        <b-card class="card-accent-primary card-style" header="A Receber - Clientes">
          <b-card-body class="card-body-style">
            <div v-if="refundsToReceive !== null && refundsToReceive !== undefined" class="card-body-content">
              <i class="fa fa-credit-card my-success"></i>
              <p>R$ {{ refundsToReceive | formatPrice }}</p>
            </div>
            <b-spinner v-else variant="primary" size="lg"></b-spinner>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-col>

  <!-- Gestão -->
  <b-col sm="6" md="6">
    <h1 style="margin-top: 2rem; margin-bottom: .5rem;">Gestão</h1>
    <div style="width: 100%; height: 1px; background-color: #ccc; margin-bottom: 2rem"></div>

    <!-- Contratos -->
    <a href="/contracts"><h3>Contratos <i class="fa fa-external-link"></i></h3></a>
    <b-row>
      <b-col sm="6" md="6">
        <b-card class="card-accent-warning card-style" header="Ativos">
          <b-card-body class="card-body-style">
            <div v-if="activeContracts !== null && activeContracts !== undefined" class="card-body-content">
              <i class="fa fa-file-pdf-o"></i>
              <p>{{ activeContracts }}</p>
            </div>
            <b-spinner v-else variant="primary" size="lg"></b-spinner>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col v-if="contractsToDue" sm="6" md="6">
        <b-card class="card-accent-warning card-style" header="Vencimento em Breve">
          <b-card-body class="card-body-style">
            <div v-if="contractsToDue !== null && contractsToDue !== undefined" class="card-body-content">
              <i class="fa fa-file-pdf-o"></i>
              <p>{{ contractsToDue }}</p>
            </div>
            <b-spinner v-else variant="primary" size="lg"></b-spinner>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <div class="divider"></div>

    <!-- Timesheet -->
    <a href="/timesheet/timesheet" style="display: inline-block; height: fit-content"><h3 style="display: inline-block; margin-right: 10px; margin-top: 0.93rem">Timesheets <i class="fa fa-external-link"></i></h3></a>
    <small style="display: inline-block; margin-top: -2rem" class="text-muted">Semanal</small>
    <b-row>
      <b-col sm="3" md="6">
        <b-card class="card-accent-warning card-style" header="Pendentes de Revisão">
          <b-card-body class="card-body-style">
            <div v-if="timesheetsPendingReview !== null && timesheetsPendingReview !== undefined" class="card-body-content">
              <i class="fa fa-search"></i>
              <p>{{ timesheetsPendingReview }}</p>
            </div>
            <b-spinner v-else variant="primary" size="lg"></b-spinner>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" md="6">
        <b-card class="card-accent-warning card-style" header="Horas Registradas">
          <b-card-body class="card-body-style">
            <div v-if="officeTotalHoursWorked !== null && officeTotalHoursWorked !== undefined" class="card-body-content">
              <i class="fa fa-clock-o"></i>
              <p>{{ officeTotalHoursWorked }}</p>
            </div>
            <b-spinner v-else variant="primary" size="lg"></b-spinner>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-col>
</b-row>

    <!-- Visão Geral -->
      <!--<b-col md="6" v-if="$store.getters['auth/isAdmin']">
        <b-card header="Últimos lançamentos de Reembolsos">
          <div class="row">
            <div class="col-sm-6">
              <div class="callout callout-info">
                <small class="text-muted">Reembolsos</small>
                <br>
                <strong class="h4">5</strong>
                <div class="chart-wrapper">
                  <canvas id="sparkline-chart-1" width="100" height="30"></canvas>
                </div>
              </div>
            </div>
          </div>
          <table class="table table-responsive-sm b-table">
            <thead>
              <tr>
                <th>Centro de custo</th>
                <th>Descrição</th>
                <th>Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in items">
                <td class="text-muted">
                  <small>{{ item.payment_date | formatDate }}</small> <br>
                  <span class="mr-2">
                    <i class="fa fa-circle my-primary" :class="{ 'my-success': getCostCenter(item) }"></i>
                  </span>
                  <span v-if="getCostCenter(item)" v-tooltip.top="'Cliente'">{{ getCostCenter(item) }}</span>
                  <span v-else v-tooltip.top="'Funcionário'">{{ getCostCenterEmployee(item) }}</span>
                </td>
                <td>{{ item.description }}</td>
                <td style="width: 25%">
                  R$ <span class="pull-right">
                    <span class="the-price">{{ item.value | formatPrice }}</span>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </b-card>
      </b-col>-->
  </div>
  <div v-else class="animated fadeIn">
    <h1 style="margin-top: 2rem;">Olá, {{ $store.state.auth.user.first_name }}</h1>
  </div>
</template>
<script>
import CardLine1ChartExample from './dashboard/CardLine1ChartExample'
import CardLine2ChartExample from './dashboard/CardLine2ChartExample'
import CardLine3ChartExample from './dashboard/CardLine3ChartExample'
import CardBarChartExample from './dashboard/CardBarChartExample'
import MainChartExample from './dashboard/MainChartExample'
import SocialBoxChartExample from './dashboard/SocialBoxChartExample'
import CalloutChartExample from './dashboard/CalloutChartExample'
import { Callout } from '@coreui/vue'
import axios from 'axios';

export default {
  name: 'dashboard',
  components: {
    //Callout,
    // CardLine1ChartExample,
    // CardLine2ChartExample,
    //CardLine3ChartExample,
    //CardBarChartExample,
    //MainChartExample,
    //SocialBoxChartExample,
    //CalloutChartExample,
  },
  data: function() {
    return {
      selected: 'Month',
      totalToReceive: null,
      totalReceived: null,
      refundsToReceive: null,
      activeContracts: null,
      contractsToDue: null,
      timesheetsPendingReview: null,
      officeTotalHoursWorked: null,
      totalToPayEmployees: null
    }
  },
  mounted() {
    if (this.$store.getters['auth/isAdmin']) {
      this.$store.dispatch('refunds/loadItems');
      this.$store.dispatch('financial/loadCostCenters');
      this.$store.dispatch('financial/loadCostCentersEmployees');
    }

    /*** Carregando informações do Dashboard ***/

    /* Financeiro */

    //Recebíveis

    // Total a receber
    axios.post('/financial/receivable/total_amount_not_paid/')
    .then((response) => {
      const status = response.status

      if (status == 200) {
        this.totalToReceive = parseFloat(response.data.total_amount)
      } else {
        this.totalToReceive = 0
      }
    })

    // Total recebido
    axios.post('/financial/receivable/total_amount_paid/')
    .then((response) => {
      const status = response.status

      if (status == 200) {
        this.totalReceived = response.data.total_amount
      } else {
        this.totalReceived = 0
      }
    })

    
    // Reembolsos

    // Total a pagar
    axios.post('/financial/refund/total_amount_to_pay_employees/')
    .then((response) => {
      if (response.status == 200) {
        this.totalToPayEmployees = response.data.total_amount
      } else {
        this.totalToPayEmployees = 0
      }
    })

    // Total a receber
    axios.post('/financial/receivable/total_amount_from_refunds_to_receive_from_clients/')
    .then((response) => {
      if (response.status == 200) {
        this.refundsToReceive = parseFloat(response.data.total_amount)
      } else {
        this.refundsToReceive = 0
      }
    })

    
    /* Gestão */

    // Contratos

    // Ativos
    axios.post('/contract/number_of_active_contracts/')
    .then((response) => {
      if (response.status == 200) {
        this.activeContracts = response.data.total
      } else {
        this.activeContracts = 0
      }
    })

    // Vencimento em Breve
    axios.post('/contract/number_of_contracts_to_due/')
    .then((response) => {
      if (response.status == 200) {
        this.contractsToDue = response.data.total
      } else {
        this.contractsToDue = 0
      }
    })

    // Timesheets pendentes de revisão
    axios.post('/timesheet/total_not_conferred/')
    .then((response) => {
      if (response.status == 200) {
        this.timesheetsPendingReview = response.data.total
      } else {
        this.timesheetsPendingReview = 0
      }
    })

    // Horas trabalhadas do escritório
    axios.post('/timesheet/office_total_hours_worked/')
    .then((response) => {
      if (response.status == 200) {
        this.officeTotalHoursWorked = response.data.total_hours_worked
      } else {
        this.officeTotalHoursWorked = 0
      }
    })
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    items: function() {
      return this.$store.state.refunds.items.sort((a, b) => new Date(b.created) - new Date(a.created)).slice(0, 5);
    },
    cost_centers() {
      return this.$store.state.financial.cost_centers;
    },
    cost_centers_employees() {
      return this.$store.state.financial.cost_centers_employees;
    }
  },
  methods: {
    variant(value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },
    flag(value) {
      return 'flag-icon flag-icon-' + value
    },
    getCostCenter(item) {
      const cost_center = this.cost_centers.find(p => p.value == item.cost_center_pk);
      return cost_center ? cost_center.text : this.cost_centers.length == 0 ? 'Carregando...' : '';
    },
    getCostCenterEmployee(item) {
      const cost_center_employee = this.cost_centers_employees.find(p => p.value == item.cost_center_employee_pk);
      return cost_center_employee ? cost_center_employee.text : this.cost_centers_employees.length == 0 ? 'Carregando...' : '';
    }
  }
}

</script>
<style scoped>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}

a {
  display: block;
  width: fit-content;
}

.my-primary {
  color: #20a8d8;
}

.my-success {
  color: #4dbd74;
}


.divider {
  width: 790px; 
  height: 1px; 
  background-color: #ccc; 
  margin: 0.5rem 0;
}

h3 {
  margin-top: 1.5rem; 
  margin-bottom: 1rem;
  color: #1a1a1a;
}

h3 i {
  font-size: 0.9rem;
}

.card-style {
  max-width: 395px;
  height: 215px;
  font-size: 1.05rem;
  border-radius: 18px;
}

.card-header {
  border-top-left-radius: 18px;
  border-top-right-radius: 18px;
}

.card-body-style {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
}

.card-body-style i {
  font-size: 1.25rem; 
  margin-top: -0.75rem;
  margin-left: -1.25rem;
}

.card-body-style p {
  font-size: 1.4rem; 
  margin-top: .25rem;
}

.card-body-content {
  display: flex; 
  align-items: center; 
  gap: 0.75rem
}

</style>
